export default __webpack_public_path__ + "6810c2c5977a4c7abde5ec7aa7d13b71.png";